import React from 'react';

const AgregarFuncion = (props) => {
    let filterFunctionalities = props.funciones_tabla.filter(x => props.funciones.findIndex(y => y.Id == x.Id) < 0);

    let funciones = filterFunctionalities.map(function (func) {
        return (
            <li className="clickable" key={"Function_" + func.Id}>
                <a onClick={() => props.addFuncion(props.perfilId, func)}>{func.Descripcion}</a>
            </li>
        );
    });

    return (
        <li className="inlineListItem">
            <div className="btn-group">
                <button className="btn-tag btn-tag-closable btn-tag-add" type="button" data-toggle="dropdown">
                    <span className="ti-plus span-closable color-white" title="Agregar función"></span>
                </button>
                <ul className="dropdown-menu dropdown-functions no-padding">
                    {funciones}
                </ul>
            </div>
        </li>
    );
}

export default AgregarFuncion;